export default "__VITE_ASSET__D0F9WnCf__"